import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { CategoryModel } from "../models/categories/categoryDTO";
import { IGridOption } from "../models/shared/gridOption";
let CategoriesModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e;
    let CategoriesModule = class CategoriesModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "Category";
            this.categories = [];
            this.totalCount = 0;
        }
        async GetCategories(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.ListCategories(plainToClass(CategoryModel, data.categories));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        ListCategories(categories) {
            this.categories = categories;
        }
        async SetTotalCount(totalCount) {
            this.totalCount = totalCount;
        }
        async SaveCategory(category) {
            var url = `${getTenantId()}/${this.apiNode}/add`;
            let { data } = await service.post(url, category);
            return data;
        }
        async UpdateCategory(updateCategory) {
            var url = `${getTenantId()}/${this.apiNode}/` + "update";
            let { data } = await service.post(url, updateCategory);
            return data;
        }
        async DeleteCategoryById(categoryId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/` + categoryId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IGridOption !== "undefined" && IGridOption) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], CategoriesModule.prototype, "GetCategories", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], CategoriesModule.prototype, "ListCategories", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], CategoriesModule.prototype, "SetTotalCount", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof CategoryModel !== "undefined" && CategoryModel) === "function" ? _c : Object]),
        __metadata("design:returntype", Promise)
    ], CategoriesModule.prototype, "SaveCategory", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof CategoryModel !== "undefined" && CategoryModel) === "function" ? _d : Object]),
        __metadata("design:returntype", Promise)
    ], CategoriesModule.prototype, "UpdateCategory", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof Guid !== "undefined" && Guid) === "function" ? _e : Object]),
        __metadata("design:returntype", Promise)
    ], CategoriesModule.prototype, "DeleteCategoryById", null);
    CategoriesModule = __decorate([
        Module({ dynamic: true, store: store, name: "categories", namespaced: true })
    ], CategoriesModule);
    return CategoriesModule;
})();
export const CategoryModule = getModule(CategoriesModule);
